import { Component, ElementRef, Input, ChangeDetectionStrategy, ChangeDetectorRef, Output,EventEmitter } from "@angular/core";

import { Dataset, Account, FourDService} from "4d-mapper";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { filter } from "rxjs/operators";

import { FileDataService, FileEvent } from "../file-data.service";
import { ArrayStore, Store } from 'vasat/dist/src/veflux'
import { TreeNode, TreeEvent } from "./tree-events";
import { StreamDataService } from "../stream-data.service";
import { KeyboardService } from "../keyboard.service";


@Component({
  selector: 'file-list',
  template: 
  `
  <file-node *ngFor="let cur of _files" [file]="cur" [selected]="_selectedFilesStore" (change)="changed($event)"></file-node>`,
  styleUrls: ['./file_list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush

})
export class FileListComponent{

  _files:Dataset[] = []
  _selectedFiles:Dataset[] = []

  _selectedFilesStore:ArrayStore<Dataset,string,FileEvent>
  _filesStore:ArrayStore<Dataset,string,FileEvent>
  
  private _subs:Subscription[] = []
  private _selectedFolder:Store<TreeNode,any,TreeEvent>
 
  @Input()
  set selectedFolder(s:Store<TreeNode,any,TreeEvent>){
    this._selectedFolder = s
  }
  @Input()
  set selectedFiles(s:ArrayStore<Dataset,string,FileEvent>){
    this._selectedFilesStore = s
  }
  @Input()
  set files(s:ArrayStore<Dataset,string,FileEvent>){
      this._filesStore = s
  }

  @Input()
  disableSelection:boolean

  @Output()
  change = new EventEmitter<FileEvent>()
  

  constructor(
    public streamManager:StreamDataService,
    public keys:KeyboardService,
    private fourD:FourDService,
    private cdr:ChangeDetectorRef) {}

  ngOnInit(){

    this._subs.push(this._selectedFolder.events.subscribe(s => {
      if(s.event == 'ADD'){
        var baseQ = this.fourD.V
          .searchByObject(Dataset)
          .limit(40)
          .useCache(true)

        if(s.item.ref instanceof Account)
          baseQ = baseQ.equals('folder','null').equals('account',s.item.ref.id)
        else
          baseQ = baseQ.equals('folder',s.item.ref.id)

        baseQ.queryObservable()
          .subscribe(s => {
            this._filesStore.values = s.items
          })
      }
      else if(s.event == 'REMOVE'){
        this._filesStore.values = []
      }
    }))

    this._subs.push(this._filesStore.state.subscribe(f => {
      this._files = f
      this.cdr.detectChanges()
    }))
    this._subs.push(this._selectedFilesStore.state.subscribe(f => {
      this._selectedFiles = f
      this.cdr.detectChanges()
    }))

    this._subs.push(this.streamManager.fileEvents.filter(ev => ev.item.folder == this._selectedFolder.value.ref).subscribe(ev => {
        if(ev.event == 'uploading')
          this._filesStore.set(ev.item)
        else if(ev.event == 'REMOVE')
          this._filesStore.remove(ev.item)

        this.cdr.detectChanges()
      })
    )
  }
  ngOnDestroy(){
    this._subs.forEach(s => s.unsubscribe())
  }

  changed(ev:FileEvent){
    this.change.emit(ev)
    if(!this.disableSelection && ev.event == 'selected')
      if(this.keys.isCtrl){
        var exists = this._selectedFilesStore.contains(ev.item)
        if(exists)
          this._selectedFilesStore.remove(ev.item)
        else
          this._selectedFilesStore.add(ev.item)
      }
      else 
        this._selectedFilesStore.values = [ev.item]
  }
}



@Component({
  selector:'file-node',
  template:`<div class="fdm_file">
      <div class="title" [ngClass]="{
        selected:isSelected,
        processing:isProcessing,
        uploading:isUploading,
        incomplete:file.incomplete,
        plottable:canPlot
      }" (click)="clicked()">
         {{ file.name }} <small>{{ file.dataType?.name }}</small>
      </div>
  </div>`,
  styleUrls:['./file_list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FileNode{
  @Input()
  file:Dataset

  @Input()
  selected = new ArrayStore(FileEvent)

  @Output()
  change = new EventEmitter<FileEvent>()
  
  isSelected:boolean
  isProcessing:boolean
  isUploading:boolean
  canPlot:boolean
  private subs:Subscription[] = []

  constructor(private stream:StreamDataService,private cdr:ChangeDetectorRef){
       
  }
  ngOnInit(){
    this.canPlot = this.file['canPlot']
    this.subs.push(this.stream.fileEvents.pipe(filter(ev => ev.item == this.file)).subscribe(ev => {
      if(ev.event == 'uploading')
        this.isUploading = true
      else if(ev.event == 'upload_finished')
        this.isUploading = false
      else if(ev.event == 'processing')
        this.isProcessing = true
      else if(ev.event == 'processing_finished')
        this.isProcessing = false

      this.cdr.detectChanges()
    }))

  }
  ngOnDestroy(){
    this.subs.forEach(s => s.unsubscribe())
  }
  clicked(){
    this.change.emit(new FileEvent(this.file,'selected'))
  }
}